import React, { useState, useEffect } from "react";

import Home from './pages/Home';
import Login from './pages/Login';
import Registration from './pages/Registration';
import NotFoundPage from './pages/NotFoundPage';
import Mailbox from './pages/Mailbox';
import PasswordForgot from './pages/PasswordForgot';
import PasswordForgotUpdate from './pages/PasswordForgotUpdate';
import Privacy from './pages/Privacy';
import Contact from './pages/Contact';

const AllRoutes = {

	routes: [
		{	// Mailbox | list
			element:  <Mailbox 
				params={{
					pageName: 	'Mailbox',
					pageTitle: 	'Mailboxes Lists',
				}}
			/>,
			path: 'mailbox/list',
		},
		{	// Home
			element:  <Home />,
			path: 'home',
		},
		{	// Home
			element:  <Home />,
			path: '',
		},
		{	// Login
			element:  <Login />,
			path: 'login',
		},
		{	// Registration
			element:  <Registration />,
			path: 'registration',
		},
		{	// Password | Forgot
			element:  <PasswordForgot />,
			path: 'password/forgot',
		},
		{	// Password | Forgot | update
			element:  <PasswordForgotUpdate />,
			path: 	'password/forgot/update',
		},
		{	// Not found page
			element: <NotFoundPage />,
			path: '/*',
		},
		{	// Contact page
			element: <Contact />,
			path: 'contact',
		},
		{	// Privacy page
			element: <Privacy />,
			path: '/privacy',
		},
	],
}

export default AllRoutes;
